import React, { ReactNode, useMemo } from 'react';
import { ListFilterService, VisibilityState } from './types';
import { ListReactContext, useListContext } from './ListContext';
import { aggregateFilters } from './VisibilityStateClientSideFilter';

export interface ClientSideFilterProps {
  children: ReactNode,
  filters: ListFilterService[],
  noDataMessage?: ReactNode,
  noDataMatchingFilterMessage?: ReactNode,
}

export function ClientSideFilter<DataType, FilterType>(props: ClientSideFilterProps) {
  const listContext = useListContext<DataType, FilterType>();

  const allFilters = aggregateFilters(props.filters);

  const contextValue = useMemo(() => {
    const { data } = listContext;

    const newData: DataType[] = [];

    data?.forEach((item: DataType) => {
      if (allFilters.applyFilter(item, data) === VisibilityState.VISIBLE) {
        newData.push(item);
      }
    });

    return {
      ...listContext,
      data: newData,
    };
  }, [JSON.stringify(listContext.filterValues), listContext.version, listContext.data?.length, listContext.isLoading]);

  const hasOriginalData = listContext.data && listContext.data.length > 0;
  const hasFilteredData = contextValue.data.length > 0;

  if (!hasOriginalData && props.noDataMessage) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{props.noDataMessage}</>;
  }

  if (hasOriginalData && !hasFilteredData && props.noDataMatchingFilterMessage) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{props.noDataMatchingFilterMessage}</>;
  }

  return (
    <ListReactContext.Provider value={contextValue}>
      {props.children}
    </ListReactContext.Provider>
  );
}
